import { required, email, minLength, sameAs, maxLength, helpers } from '@vuelidate/validators'

const MAX_LEN_EMAIL = 32
const MAX_LEN_NAME = 32
const MAX_LEN_PASSWORD = 32

function minLengthMessage (len) {
    return `Este campo deve conter no mínimo ${len} caracteres`
}

function maxLengthMessage (len) {
    return `Este campo deve conter no máximo ${len} caracteres`
}

function requiredMessage () {
    return `Este campo é obrigatório`
}

function fullNameMessage () {
    return `Este campo deve conter o nome completo`
}

function emailMessage () {
    return `Este não é um email válido`
}

function passwordConfirmationMessage () {
    return `As senhas devem ser iguais`
}

function specialCharacterMessage () {
    return `A senha deve conter ao menos um caractere especial`
}

function oneUpperCharacterMessage () {
    return `A senha deve conter ao menos um caractere maiúsculo`
}

function oneLowerCharacterMessage () {
    return `A senha deve conter ao menos um caractere minúsculo`
}

function oneNumberCharacterMessage () {
    return `A senha deve conter ao menos um número`
}

function arrayContaisValueMessage () {
    return `Esse dado não existe`
}

const containsWhiteSpace = (value) => value.includes(' ')
const specialCharacter = (value) => /^(?=.*[!@#$%^&*])/.test(value)
const oneUpperCharacter = (value) => /^(?=.*[A-Z])/.test(value)
const oneLowerCharacter = (value) => /^(?=.*[a-z])/.test(value)
const oneNumberCharacter = (value) => /^(?=.*[0-9])/.test(value)

const includesValue = (param) => helpers.withParams({ array: param }, (value) => array.includes(value))

export function nomeFantasia () {
    const min = minLength(4)
    const max = maxLength(32)
    const rules = {
        required:
            helpers.withMessage(requiredMessage(), required),
        minLength:
            helpers.withMessage(minLengthMessage(min.$params.min), min),
        maxLength:
            helpers.withMessage(maxLengthMessage(max.$params.max), max),
        contains:
            helpers.withMessage(fullNameMessage(), containsWhiteSpace)
    }
    return rules
}

export function personNameNotRequired () {
    const min = minLength(4)
    const max = maxLength(32)
    const rules = {
        minLength:
            helpers.withMessage(minLengthMessage(min.$params.min), min),
        maxLength:
            helpers.withMessage(maxLengthMessage(max.$params.max), max)
    }
    return rules
}

export function personName () {
    const min = minLength(4)
    const max = maxLength(32)
    const rules = {
        required:
            helpers.withMessage(requiredMessage(), required),
        minLength:
            helpers.withMessage(minLengthMessage(min.$params.min), min),
        maxLength:
            helpers.withMessage(maxLengthMessage(max.$params.max), max),
        contains:
            helpers.withMessage(fullNameMessage(), containsWhiteSpace)
    }
    return rules
}
export function phone () {
    const min = minLength(14) // (##) ####-####
    const rules = {
        required:
            helpers.withMessage(requiredMessage(), required),
        minLength:
            helpers.withMessage('Telefone inválido', min)
    }
    return rules
}

export function phone2 () {
    const rules = phone()
    delete rules.required
    return rules
}

export function cnpjValidator () {
    const min = minLength(18) // ##.###.###/####-##
    const rules = {
        required:
            helpers.withMessage(requiredMessage(), required),
        minLength:
            helpers.withMessage('CNPJ inválido', min)
    }
    return rules
}

export function ramal () {
    const min = minLength(4) // (##) ####-####
    const max = maxLength(4) // (##) # ####-####
    const rules = {
        required:
            helpers.withMessage(requiredMessage(), required),
        minLength:
            helpers.withMessage(minLengthMessage(min.$params.min), min),
        maxLength:
            helpers.withMessage(maxLengthMessage(max.$params.max), max)
    }
    return rules
}
export function emailValidator () {
    const max = maxLength(128)
    const rules = {
        required:
            helpers.withMessage(requiredMessage(), required),
        email:
            helpers.withMessage(emailMessage(), email),
        maxLength:
            helpers.withMessage(maxLengthMessage(max.$params.max), max)
    }
    return rules
}
export function passwordRegistration () {
    const min = minLength(8)
    const max = maxLength(20)
    const rules = {
        required:
            helpers.withMessage(requiredMessage(), required),
        minLength:
            helpers.withMessage(minLengthMessage(min.$params.min), min),
        maxLength:
            helpers.withMessage(maxLengthMessage(max.$params.max), max),
        specialCharacter:
            helpers.withMessage(specialCharacterMessage(), specialCharacter),
        oneUpperCharacter:
            helpers.withMessage(oneUpperCharacterMessage(), oneUpperCharacter),
        oneLowerCharacter:
            helpers.withMessage(oneLowerCharacterMessage(), oneLowerCharacter),
        oneNumberCharacter:
            helpers.withMessage(oneNumberCharacterMessage(), oneNumberCharacter)
    }
    return rules
}

export function passwordConfirmationRegistration (able) {
    const rules = {
        required:
            helpers.withMessage(requiredMessage(), required),
        sameAs:
            helpers.withMessage(passwordConfirmationMessage, sameAs(able))
            // helpers.withMessage(passwordConfirmationMessage(), sameAs(a)),

    }
    return rules
}

export function passwordLogin () {
    const min = minLength(8)
    const max = maxLength(32)
    const rules = {
        required:
            helpers.withMessage(requiredMessage(), required),
        minLength:
            helpers.withMessage(minLengthMessage(min.$params.min), min),
        maxLength:
            helpers.withMessage(maxLengthMessage(max.$params.max), max)
    }
    return rules
}
export function requiredOnly () {
    const rules = {
        required:
            helpers.withMessage(requiredMessage(), required)
    }
    return rules
}

export function arrayContainsValue () {
    const rules = {
        containsValue:
            helpers.withMessage(includesValue(), arrayContaisValueMessage())
    }
    return rules
}

export function enderecoValidator () {
    const enderecoMin = minLength(8)
    const enderecoMax = maxLength(64)

    const cidadeMin = minLength(3)
    const cidadeMax = maxLength(32)

    const numMax = maxLength(6)

    const cepMin = minLength(10)
    const rules = {
        cep: {
            required:
                helpers.withMessage(requiredMessage(), required),
            minLength:
                helpers.withMessage('CEP inválido', cepMin)
        },
        cidade: {
            required:
                helpers.withMessage(requiredMessage(), required),
            minLength:
                helpers.withMessage(minLengthMessage(cidadeMin.$params.min), cidadeMin),
            maxLength:
                helpers.withMessage(maxLengthMessage(cidadeMax.$params.max), cidadeMax)
        },
        complemento: {
            maxLength:
                helpers.withMessage(maxLengthMessage(enderecoMax.$params.max), enderecoMax)
        },
        endereco: {
            required:
                helpers.withMessage(requiredMessage(), required),
            minLength:
                helpers.withMessage(minLengthMessage(enderecoMin.$params.min), enderecoMin),
            maxLength:
                helpers.withMessage(maxLengthMessage(enderecoMax.$params.max), enderecoMax)
        },
        numero: {
            // minLength:
            //     helpers.withMessage(minLengthMessage(numMin.$params.min), numMin),
            maxLength:
                helpers.withMessage(maxLengthMessage(numMax.$params.max), numMax)
        },
        uf_id: {
            // required:
            //     helpers.withMessage(requiredMessage(), required)
        },
        bairro: {
            required:
                helpers.withMessage(requiredMessage(), required),
            minLength:
                helpers.withMessage(minLengthMessage(cidadeMin.$params.min), cidadeMin),
            maxLength:
                helpers.withMessage(maxLengthMessage(cidadeMax.$params.max), cidadeMax)
        }
    }
    return rules
}
